function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import e, { useRef as r, useCallback as t, useEffect as n, Fragment as c } from "react";
import o from "animejs";

function a() {
  return (a = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function l(e) {
  var r = [];
  return u(e, r), r;
}

function u(e, r) {
  for (var _t = 0; _t < e.length; _t++) {
    var _n = e[_t];
    Array.isArray(_n) ? u(_n, r) : r.push(_n);
  }
}

function i(u) {
  var i = r([]),
      s = r([]),
      p = r(null),
      f = r(new Set()),
      m = t(function () {
    i.current.length > 0 && void 0 !== p && o.remove(i), i.current = [];

    var _iterator = _createForOfIteratorHelper(s.current),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;
        _e.current && !f.current.has(_e.current) && i.current.push(_e.current);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var e = a({}, u, {
      targets: i.current,
      complete: function complete(e) {
        u.complete && u.complete(e), e.animatables.map(function (e) {
          return f.current.add(e.target);
        });
      }
    });
    delete e.children, delete e.svg, p.current = o(e);
  }, [u]);
  n(function () {
    m();
  }, [m]);
  var h = s.current;
  var d = Array.isArray(u.children) ? u.children : [u.children];
  return d = l(d), e.createElement(c, null, d.map(function (r, t) {
    return h.push(e.createRef()), e.createElement(u.svg ? "g" : "div", {
      ref: h[h.length - 1],
      key: "__anime__".concat(t)
    }, r);
  }));
}

export default i;